// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4351":"d5db1ffc","5350":"d5db1ffc","8109":"7100043d","8931":"d5db1ffc"}[chunkId] + ".chunk.css";
};